import { ButtonProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { getResponsiveButtonIcon } from './getResponsiveButtonIcon';

const ButtonTextWrapper = styled.span``;
const SpacedItem = styled.span`
  margin-left: 8px;
`;

export interface ButtonResponsiveProps extends Omit<ButtonProps, 'icon'> {
  text?: React.ReactNode;
  // gestione aria label delle icon e in base al mobile
  iconLeftComponent?: React.ComponentType;
  iconLeftAriaLabel?: string;
  iconRightComponent?: React.ComponentType;
  iconRightAriaLabel?: string;

  // per forzare visualizzazione desktop
  ignoreMobile?: boolean;
}

/**
 * Pulsante con modalità responsive
 * per eliminare il testo e lasciare solo l'icona in caso di spazi ridotti
 *
 * Se viene passata l'icona destra questa sarà sempre visibile
 */

export function getResponsiveButtonProps(
  props: ButtonResponsiveProps,
  isMobile?: boolean | null,
) {
  const {
    text,
    children,
    ignoreMobile,
    iconLeftComponent,
    iconLeftAriaLabel,
    iconRightComponent,
    iconRightAriaLabel,
    ...buttonProps
  } = props;
  // verifichiamo se siamo in visualizzazione Mobile
  const mobile = ignoreMobile ? false : isMobile;
  // Otteniamo le icone in base alla modalità di visualizzazione
  const iconLeft = getResponsiveButtonIcon(
    iconLeftComponent,
    iconLeftAriaLabel,
    mobile,
  );
  const iconRight = getResponsiveButtonIcon(
    iconRightComponent,
    iconRightAriaLabel,
    mobile,
  );
  return {
    ...buttonProps,
    icon: mobile ? iconRight ?? iconLeft : iconLeft,
    children: mobile ? undefined : (
      <ButtonTextWrapper>
        <span>{text ?? children}</span>
        {iconRight && <SpacedItem>{iconRight}</SpacedItem>}
      </ButtonTextWrapper>
    ),
  } satisfies ButtonProps;
}
